// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes scaleIn {
  from {
    transform: scale(0.3);
  }
  to {
    transform: scale(1);
  }
}

@keyframes scaleOut {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0%;
  }
  to {
    opacity: 100%;
  }
}

@keyframes fadeOut {
  from {
    opacity: 100%;
  }
  to {
    opacity: 0%;
  }
}

@keyframes slideIn {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0%);
  }
}

@keyframes slideOut {
  from {
    transform: translateX(0%);
  }
  to {
    transform: translateX(-100%);
  }
}

@keyframes swipeDown {
  from {
    transform: translateY(-100vh);
  }
  to {
    transform: translateY(0%);
  }
}
@keyframes swipeUp {
  from {
    transform: translateY(100vh);
  }
  to {
    transform: translateY(0%);
  }
}
@keyframes swipeLeft {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0%);
  }
}
@keyframes swipeRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0%);
  }
}

.navBar {
  padding: 24px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: top;
  width: 70%;
  margin-left: 15%;
  z-index: 10;
}

.nav-header {
  width: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.nav-header img {
  width: 18%;
}
.nav-items {
  padding: 12px;
  width: 40%;
}
.nav-items a {
  text-decoration: none;
  margin-left: 28px;
  font-size: medium;
  letter-spacing: 1px;
}
.nav-items a:hover {
  color: #56acb7;
}
.activeNav {
  color: #56acb7;
}
.inActiveNav {
  color: #000;
}

.sidebarContainer {
  position: absolute;
  width: 100%;
  padding: 18px;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
}

.sideBarImg img {
  width: 12%;
  margin-left: 5%;
}

.sideBarDrawerIcon {
  cursor: pointer;
  z-index: 13;
  animation: scaleIn 0.5s forwards;
}

.drawerIn {
  animation: slideIn 0.5s forwards;
}
.drawerOut {
  animation: slideOut 0.5s backwards;
  animation-fill-mode: forwards;
}

.sideBarDrawer {
  width: 100%;
  height: 100%;
  background-color: white;
  position: fixed;
  left: 0;
  z-index: 12;
  transform: translateX(-100%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.sideBarDrawer a {
  text-decoration: none;
  font-size: 1.5rem;
  font-weight: 400;
  margin: 12px;
  width: 100%;
  text-align: center;
}
.drawerItemsAnimation1 {
  transform: translateY(-100vh);
  animation: swipeDown 1s forwards;
}
.drawerItemsAnimation2 {
  transform: translateY(100vh);
  animation: swipeUp 1s forwards;
  /* animation-delay: 0.4s; */
}
.drawerItemsAnimation3 {
  transform: translateX(-100%);
  animation: swipeLeft 1s forwards;
  /* animation-delay: 0.5s; */
}
.drawerItemsAnimation4 {
  transform: translateX(100%);
  animation: swipeRight 1s forwards;
  /* animation-delay: 0.6s; */
}

.sideBarImgContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  margin-top: 10%;
}
.sideBarImgContainer img {
  width: 40%;
  opacity: 0;
  animation: fadeIn 1s forwards;
  animation-delay: 0.5s;
}
.sideBarDrawer p {
  position: absolute;
  bottom: 0;
  color: lightslategray;
  margin-bottom: 2%;
  font-size: small;
}

.overlay {
  width: 60%;
  height: 20%;
  position: absolute;
  left: 0;
  top: 0;
  background-color: #e5fbfe;
  z-index: -1;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/NavBar/navbar.css"],"names":[],"mappings":"AAAA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;AACA;EACE,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,OAAO;EACP,WAAW;EACX,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,MAAM;EACN,eAAe;AACjB;AACA;EACE,UAAU;EACV,UAAU;EACV,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,yBAAyB;EACzB,WAAW;AACb","sourcesContent":["@keyframes scaleIn {\n  from {\n    transform: scale(0.3);\n  }\n  to {\n    transform: scale(1);\n  }\n}\n\n@keyframes scaleOut {\n  from {\n    transform: scale(1);\n  }\n  to {\n    transform: scale(0);\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0%;\n  }\n  to {\n    opacity: 100%;\n  }\n}\n\n@keyframes fadeOut {\n  from {\n    opacity: 100%;\n  }\n  to {\n    opacity: 0%;\n  }\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateX(-100%);\n  }\n  to {\n    transform: translateX(0%);\n  }\n}\n\n@keyframes slideOut {\n  from {\n    transform: translateX(0%);\n  }\n  to {\n    transform: translateX(-100%);\n  }\n}\n\n@keyframes swipeDown {\n  from {\n    transform: translateY(-100vh);\n  }\n  to {\n    transform: translateY(0%);\n  }\n}\n@keyframes swipeUp {\n  from {\n    transform: translateY(100vh);\n  }\n  to {\n    transform: translateY(0%);\n  }\n}\n@keyframes swipeLeft {\n  from {\n    transform: translateX(-100%);\n  }\n  to {\n    transform: translateX(0%);\n  }\n}\n@keyframes swipeRight {\n  from {\n    transform: translateX(100%);\n  }\n  to {\n    transform: translateX(0%);\n  }\n}\n\n.navBar {\n  padding: 24px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  position: top;\n  width: 70%;\n  margin-left: 15%;\n  z-index: 10;\n}\n\n.nav-header {\n  width: 20%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.nav-header img {\n  width: 18%;\n}\n.nav-items {\n  padding: 12px;\n  width: 40%;\n}\n.nav-items a {\n  text-decoration: none;\n  margin-left: 28px;\n  font-size: medium;\n  letter-spacing: 1px;\n}\n.nav-items a:hover {\n  color: #56acb7;\n}\n.activeNav {\n  color: #56acb7;\n}\n.inActiveNav {\n  color: #000;\n}\n\n.sidebarContainer {\n  position: absolute;\n  width: 100%;\n  padding: 18px;\n  display: flex;\n  justify-content: space-between;\n  overflow: hidden;\n}\n\n.sideBarImg img {\n  width: 12%;\n  margin-left: 5%;\n}\n\n.sideBarDrawerIcon {\n  cursor: pointer;\n  z-index: 13;\n  animation: scaleIn 0.5s forwards;\n}\n\n.drawerIn {\n  animation: slideIn 0.5s forwards;\n}\n.drawerOut {\n  animation: slideOut 0.5s backwards;\n  animation-fill-mode: forwards;\n}\n\n.sideBarDrawer {\n  width: 100%;\n  height: 100%;\n  background-color: white;\n  position: fixed;\n  left: 0;\n  z-index: 12;\n  transform: translateX(-100%);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n}\n\n.sideBarDrawer a {\n  text-decoration: none;\n  font-size: 1.5rem;\n  font-weight: 400;\n  margin: 12px;\n  width: 100%;\n  text-align: center;\n}\n.drawerItemsAnimation1 {\n  transform: translateY(-100vh);\n  animation: swipeDown 1s forwards;\n}\n.drawerItemsAnimation2 {\n  transform: translateY(100vh);\n  animation: swipeUp 1s forwards;\n  /* animation-delay: 0.4s; */\n}\n.drawerItemsAnimation3 {\n  transform: translateX(-100%);\n  animation: swipeLeft 1s forwards;\n  /* animation-delay: 0.5s; */\n}\n.drawerItemsAnimation4 {\n  transform: translateX(100%);\n  animation: swipeRight 1s forwards;\n  /* animation-delay: 0.6s; */\n}\n\n.sideBarImgContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  margin-top: 10%;\n}\n.sideBarImgContainer img {\n  width: 40%;\n  opacity: 0;\n  animation: fadeIn 1s forwards;\n  animation-delay: 0.5s;\n}\n.sideBarDrawer p {\n  position: absolute;\n  bottom: 0;\n  color: lightslategray;\n  margin-bottom: 2%;\n  font-size: small;\n}\n\n.overlay {\n  width: 60%;\n  height: 20%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  background-color: #e5fbfe;\n  z-index: -1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
